module.exports = __webpack_public_path__ + "static/img/cust-01.6bc1d20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cust-01.png
// module id = pYnE
// module chunks = 29